module.exports = "<plugin-apollo-main></plugin-apollo-main>\n"